// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1442":"84841488f843e8af","3471":"05c32fe0f092c7bf"}[chunkId] + ".js";
};